import ComponentHierarchy from './ComponentHierarchy';
export * from './ComponentHierarchy';
export default ComponentHierarchy;
